import { useEffect, useState } from "react";
import { useDataProvider, type Identifier } from "ra-core";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";

import type { CampaignProgressSummary as CampaignProgressData } from "../types";

export const CampaignProgressSummaryPanel = ({
  campaignId,
  onFilterStatus,
  activeStatus,
}: {
  campaignId: Identifier;
  onFilterStatus?: (status: string | null) => void;
  activeStatus?: string | null;
}) => {
  const dataProvider = useDataProvider();
  const [progress, setProgress] = useState<CampaignProgressData | null>(
    null,
  );

  useEffect(() => {
    (dataProvider as any)
      .getCampaignProgress(campaignId)
      .then(setProgress)
      .catch(() => setProgress(null));
  }, [campaignId, dataProvider]);

  if (!progress || progress.total === 0) {
    return (
      <p className="text-sm text-muted-foreground">No tasks generated yet.</p>
    );
  }

  const chips = [
    { key: "completed", label: "Completed", count: progress.completed },
    { key: "open", label: "Open", count: progress.open },
    { key: "overdue", label: "Overdue", count: progress.overdue },
    { key: "snoozed", label: "Snoozed", count: progress.snoozed },
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <Progress value={progress.completion_pct} className="h-3 flex-1" />
        <span className="text-sm font-medium">{progress.completion_pct}%</span>
      </div>
      <p className="text-sm text-muted-foreground">
        {progress.completed} / {progress.total} tasks completed
      </p>
      <div className="flex flex-wrap gap-2">
        {chips.map((c) => (
          <Badge
            key={c.key}
            variant={activeStatus === c.key ? "default" : "outline"}
            className="cursor-pointer"
            onClick={() =>
              onFilterStatus?.(activeStatus === c.key ? null : c.key)
            }
          >
            {c.label}: {c.count}
          </Badge>
        ))}
      </div>
    </div>
  );
};
